import { useEffect, useState } from 'react';
import { isCandidatePwaContext } from '../pwa/candidatePwa';

const MOBILE_MAX_WIDTH = 768;

export function isCandidateMobileViewport() {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= MOBILE_MAX_WIDTH || isCandidatePwaContext();
}

/** Layout mobile/PWA para a área do candidato (Fase 3). */
export function useCandidateMobileLayout() {
  const [isMobile, setIsMobile] = useState(isCandidateMobileViewport);

  useEffect(() => {
    const update = () => setIsMobile(isCandidateMobileViewport());
    update();
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, []);

  return isMobile;
}
